import { useCallback } from "react";
import { apiFile } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";
import { defaultProject, useProject } from "../context/ProjectContext.tsx";
import { useMechanicsConfiguration } from "../context/MechanicsConfigurationContext.tsx";
import { useElectronicsConfiguration } from "../context/ElectronicsConfigurationContext.tsx";
import { useTestProcedure } from "../context/TestProcedureContext.tsx";
import { useBinaryVersion } from "./useBinaryVersion.ts";

export const useDecodeBinary = () => {

  const { handle, setError, setSuccess } = useMessageHandler();
  const { setProject } = useProject();
  const { setConfig: setMechanics } = useMechanicsConfiguration();
  const { setConfig: setElectronics } = useElectronicsConfiguration();
  const { setProcedures } = useTestProcedure();
  const { version } = useBinaryVersion();

  const isValidDecoded = (data: any) =>
    !!(data &&
      data.mechanics &&
      data.electronics &&
      Array.isArray(data.testProcedures) &&
      data.project);

  const decode = useCallback(async (file: File): Promise<any | null> => {
    const formData = new FormData();
    formData.append("file", file);

    return await handle(async () => {
      const response = await apiFile.post("/binary/decode", formData);
      const data = response.data;
      if (!data.version || data.version !== version) {
        setError("Version nicht Kompatibel. Ist: " + (data.version ?? "unbekannt") + " Soll: " + version);
      return null;
      }

      if (!isValidDecoded(data)) {
        setError("Datei enthält keine gültige Konfiguration.");
        return null;
      }

      setProject({
        ...defaultProject,
        ...data.project,
        company: {
          ...defaultProject.company,
          ...data.project.company,
        },
      });
      setMechanics(data.mechanics);
      setElectronics(data.electronics);
      setProcedures(data.testProcedures);
      setSuccess("Konfiguration erfolgreich importiert.");
      return data;
    }).catch((err: Error) => {
      setError("Ungültige Konfigurationsdatei.");
      return null;
    });
  }, [handle, version]);
  return { decode };
};
